import React, { useState } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import baseURL from "../Url/Url.jsx"

const LoginAdmin = () => {
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [msg, setMsg] = useState("")
    const [displayLoader, setDisplayLoader] = useState("none")

    const navigate = useNavigate()

    const login = async (e) => {
        e.preventDefault()
        try {
            setDisplayLoader("")
            const response = await axios.post(`${baseURL}/loginBE`, {
                userName,
                password
            })
            // if (response.data.forceChangePassword) {
            //     navigate("/admin-change-password", {
            //         state: { userId: response.data.userId }
            //     })
            //     return
            // }
            navigate("/admin/dashboard", { replace: true })
        } catch (error) {
            setDisplayLoader("none")
            if (error.response) {
                setMsg(error.response.data.msg)
            } else {
                setMsg("Terjadi kesalahan koneksi")
            }
        }
    }

    return (
        <div>
            {/* Loader */}
            <div className="loader-page-bg" style={{ display: displayLoader }}>
                <div className="loader-page"></div>
            </div>

            {/* FORM LOGIN ADMIN */}
            <div className="container mb-4" style={{ marginTop: "80px" }}>
                <div className="row justify-content-center">
                    <div className="col-11 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                        <div className="box-login">
                            <h4 className="text-center fw-bold">Login Admin</h4>
                            {msg && (<h6 className="text-center text-danger mb-3">{msg}</h6>)}
                            <form onSubmit={login}>
                                <label htmlFor="userName" className="mx-2"></label>
                                <input type="text"className="form-control form mb-2"placeholder="Username"value={userName}onChange={(e) => setUserName(e.target.value)}autoFocus required/>
                                <label htmlFor="password" className="mx-2"></label>
                                <input type="password"className="form-control form mb-4"placeholder="Password"value={password}onChange={(e) => setPassword(e.target.value)}required/>
                                <button type="submit"className="btn btn-webew-login mt-3 mb-3">Login</button>
                            </form>
                            <a href="/" className="btn btn-link mx-auto d-block p-0">Login User</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginAdmin
